import { Grid } from '@mui/material';
import * as React from 'react';
import DonutChart from 'react-donut-chart';
import { useSelector } from 'react-redux';
import { AppState } from 'src/store';

export default function ChartComponent(alldocumentStatusData: any) {
  const approvalCount: any = alldocumentStatusData.alldocumentStatus[0]?.isf_doc_Ready_for_approval_count;
  const approvedCount: any = alldocumentStatusData.alldocumentStatus[0]?.isf_doc_approved_count;
  const expectedCount: any = alldocumentStatusData.alldocumentStatus[0]?.isf_doc_expected_count;
  const rejectedCount: any = alldocumentStatusData.alldocumentStatus[0]?.isf_doc_rejected_count;
  const totalCount = alldocumentStatusData.alldocumentStatus[0]?.isf_doc_total_count;
  const uploadedCount: any = alldocumentStatusData.alldocumentStatus[0]?.isf_doc_uploaded_count;
  const sentToTmfCount: any = alldocumentStatusData.alldocumentStatus[0]?.isf_doc_sent_to_tmf_count;
  const sentToTmfTotalCount: any = alldocumentStatusData.alldocumentStatus[0]?.count_total_transfer_docs;
  const sentToTmfartifacts: any =
    sentToTmfTotalCount > 0 ? `${((sentToTmfCount / sentToTmfTotalCount) * 100).toFixed(2) || 0}` : `0`;
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);

  let IsfLevel =
    (selectedStudy === '--' || selectedStudy === '') &&
    (selectedCountry === '--' || selectedCountry == '') &&
    (selectedSite === '--' || selectedSite === '')
      ? '--'
      : (selectedCountry === '--' || selectedCountry == '') && (selectedSite === '--' || selectedSite === '')
      ? 'Study'
      : selectedSite === '--' && selectedCountry != '--'
      ? 'Country'
      : 'Site';
  if (IsfLevel === '--') {
    IsfLevel = 'Study';
  }
  const reactDonutChartdata = [
    {
      label: '',
      value: sentToTmfCount
    },
    {
      label: '',
      value: approvedCount
    },
    {
      label: '',
      value: approvalCount
    },
    {
      label: '',
      value: uploadedCount
    },
    {
      label: '',
      value: expectedCount
    },
    {
      label: '',
      value: rejectedCount
    }
  ];
  const reactDonutChartdataForIsf = [
    {
      label: '',
      value: 0
    },
    {
      label: '',
      value: 0
    },
    {
      label: '',
      value: 0
    },
    {
      label: '',
      value: sentToTmfTotalCount
    },
    {
      label: '',
      value: 0
    }
  ];
  const reactDonutChartBackgroundColor1 = ['#41B387', '#3f51b5', '#2196F3', '#41B387', '#EF8033'];
  const reactDonutChartBackgroundColor2 = ['#41B387', '#3f51b5', '#2196F3', '#6A1B9A', '#EF8033'];
  const reactDonutChartStrokeColor = '';

  const formatValues = (values: any, total: any) => `${total || 0}`;
  return (
    <>
      {IsfLevel === 'Site' ? (
        <Grid sx={{ width: '196px', display: 'inline-flex' }} className="lineRight">
          <Grid container>
            <Grid className="chart-block">
              <DonutChart
                width={72}
                height={72}
                legend={false}
                strokeColor={reactDonutChartStrokeColor}
                colors={reactDonutChartBackgroundColor1}
                formatValues={formatValues}
                data={reactDonutChartdataForIsf}
              />
            </Grid>

            <Grid className="chart-description">
              <div className="completed green">
                <strong>
                  {Math.round(sentToTmfartifacts)}
                  <span>%</span>
                </strong>
                <br />
                Sent to TMF
              </div>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        ''
      )}

      <div className="app-chart" style={{ display: 'inline-flex' }}>
        <DonutChart
          width={72}
          height={72}
          legend={false}
          strokeColor={reactDonutChartStrokeColor}
          colors={reactDonutChartBackgroundColor2}
          formatValues={formatValues}
          data={reactDonutChartdata}
        />
      </div>
    </>
  );
}
